import './StoryProgress.sass';

import React, { FC } from 'react';
import { StoryProgressProps } from './StoryProgress.interface';
import { animated } from '@react-spring/web';

export const StoryProgress: FC<StoryProgressProps> = ({ total, current, animation }) => {
  return (
    <div className="StoryProgress">
      {Array.from({ length: current }, (_, i) => (
        <div key={i} className="StoryProgress__item active" />
      ))}
      <div className="StoryProgress__item">
        <animated.div
          className="StoryProgress__item__progress"
          style={{ transform: animation.interpolate((x) => `translate(${-100+x}%, 0)`) }}
        />
      </div>
      {Array.from({ length: total - current - 1 }, (_, i) => (
        <div key={i} className="StoryProgress__item" />
      ))}
    </div>
  );
};
